// extracted by mini-css-extract-plugin
export default {"conteiner":"clients_conteiner__BHGF4","searchConteiner":"clients_searchConteiner__P7dw5"};